import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { ComplaintComms } from './ComplaintComms';

export const Route = createFileRoute('/console/$orgId/compliance/complaints/details/$id/comms')({
    component: ComplaintCommsPage,
});

function ComplaintCommsPage() {
    return (
        <PageController route={Route}>
            <ComplaintComms />
        </PageController>
    );
}
